(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name wbAuth.controller:AdminLoginCtrl
   *
   * @description
   *
   */
  angular
    .module('wbAuth')
    .controller('AdminLoginCtrl', AdminLoginCtrl);

  function AdminLoginCtrl(Auth, FormControl, _, $rootScope) {
    var vm = this
      , formControl = new FormControl();

    vm.session = {
      identifier: '',
      password: '',
      clientEmail: ''
    };

    vm.isProcessing = function isProcessing() {
      return formControl.isProcessing();
    };

    vm.getServerValidation = function getServerValidation() {
      return formControl.getServerValidation();
    };

    vm.submit = function submit() {
      setAppTransitioning();
      vm.loginForm.$setSubmitted();

      formControl
        .process(Auth.adminLogin(vm.session))
        .catch(clearAppTransitioning);

      function setAppTransitioning() {
        $rootScope.appIsTransitioning = true;
      }

      function clearAppTransitioning() {
        $rootScope.appIsTransitioning = false;
      }
    };
  }
}());
